var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 16.0605L6.46875 12.3097L7.48434 11.25L10.0625 13.9395L15.5142 8.25L16.5312 9.31125L10.0625 16.0605Z",
    fill: "#05A0FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1.5C9.50983 1.5 7.56435 2.11581 5.90958 3.26957C4.25481 4.42332 2.96507 6.0632 2.20347 7.98182C1.44186 9.90045 1.24259 12.0116 1.63085 14.0484C2.01912 16.0852 2.97748 17.9562 4.38474 19.4246C5.79201 20.8931 7.58497 21.8931 9.53691 22.2982C11.4888 22.7034 13.5121 22.4955 15.3508 21.7007C17.1894 20.906 18.761 19.5602 19.8667 17.8335C20.9723 16.1068 21.5625 14.0767 21.5625 12C21.5625 9.21523 20.5023 6.54451 18.6153 4.57538C16.7282 2.60625 14.1687 1.5 11.5 1.5ZM11.5 21C9.79414 21 8.12659 20.4722 6.70821 19.4832C5.28984 18.4943 4.18435 17.0887 3.53154 15.4442C2.87874 13.7996 2.70793 11.99 3.04073 10.2442C3.37353 8.49836 4.19498 6.89471 5.40121 5.63604C6.60744 4.37737 8.14426 3.5202 9.81735 3.17293C11.4904 2.82567 13.2246 3.0039 14.8006 3.68508C16.3767 4.36627 17.7237 5.51983 18.6714 6.99987C19.6192 8.47991 20.125 10.22 20.125 12C20.125 14.3869 19.2163 16.6761 17.5988 18.364C15.9813 20.0518 13.7875 21 11.5 21Z",
    fill: "#05A0FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.bf7237e317953b47f2e7d8702080a29d.svg";
export { ForwardRef as ReactComponent };